(function ($) {
    $(document).ready(function () {
        function getQueryParam(name) {
            let urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        }

        let entityId = getQueryParam('patientEntityId');

        if (entityId) {
            $('#ascenti-reach-cta').find('a').each(function() {
                let button = $(this);
                let href = button.attr('href');
                if (href) {
                    href += href.includes('?') ? '&' : '?';
                    href += 'patientEntityId=' + entityId;
                    button.attr('href', href);
                }
            });
        }
    });
})(window.jQuery);
